import type { UserSummary } from '@cult/schemas';
import { Flex, Typography } from 'antd';
import { UserAvatar } from '../UserAvatar/UserAvatar';

type Props = {
  user: UserSummary;
  size?: number;
};

export const UserChip = ({ user, size = 24 }: Props) => (
  <Flex align="center" gap={6}>
    <UserAvatar size={size} avatarUrl={user.avatarUrl} />
    <Typography.Text strong style={{ fontSize: 14 }}>
      {user.displayName}
    </Typography.Text>
  </Flex>
);
